import React from "react";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { PAGE_NAME, ROUTE } from "../../../../../constants/constants";
import { useDeviceListQuery } from "../../../../../store/okta/userSlice";
import { useTableHooks } from "../../../../atoms/table/useTableHooks";
import { pascalToSnakeCase } from "../../../../../utils";
import { usePaginationHook } from "../../../../molecules/pagination/usePaginationHook";
import { Input } from "../../../../atoms/input";
import { Table } from "../../../../atoms/table";
import { Divider } from "../../../../atoms/divider";
import { Pagination } from "../../../../molecules/pagination";
import { Dropdown } from "../../../../atoms/dropdown";

const toolSortFormattedHandler = (sortBy: string) => {
    if (sortBy === "deviceStatus") {
        sortBy = "status";
    }

    return sortBy;
};


export const OktaDevicesList = () => {
    const pageClassName = "p-oktaDevicesList";


    const tableHeader = [
        {
            title: "Serial",
            dataIndex: "id",
            isSortable: false,
        },
        {
            title: "Name",
            dataIndex: "name",
            isSortable: true,
        },
        {
            title: "Platform",
            dataIndex: "platform",
            isSortable: true,
        },
        {
            title: "Model",
            dataIndex: "model",
            isSortable: true,
        },
        {
            title: "Status",
            dataIndex: "deviceStatus",
            isSortable: true,
        },
        {
            title: "Number of Users",
            dataIndex: "numberOfUsers",
            isSortable: true,
        },
        {
            title: "Created",
            dataIndex: "createdAt",
            isSortable: true,
        },

    ];

    const {
        search,
        query,
        pageChangeHandler,
        sortHandler,
        limitChangeHandler,
        searchHandler,
    } = useTableHooks();

    const { data, isLoading, isFetching } = useDeviceListQuery({
        search: query.search,
        limit: query.limit,
        current_page: query.current,
        sort_by: pascalToSnakeCase(toolSortFormattedHandler(query.sortBy)),
        sort_direction: query.sortDirection,
    });


    const {
        totalData,
        handleFirstPage,
        handlePrevPage,
        handleLastPage,
        handleNextPage,
        renderPageNumbers,
    } = usePaginationHook({
        totalNumberOfData: data?.result?.total,
        perPage: query.limit,
        setCurrentPage: pageChangeHandler,
        currentPage: query.current,
        className: "m-pagination",
    });


    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>{PAGE_NAME.OKTA_DEVICE_LIST}</p>
            <div className={`${pageClassName}__container`}>
                <div className={`${pageClassName}__search`}>
                    <Input
                        placeholder="Search"
                        onChange={(e) => {
                            searchHandler(e);
                            handleFirstPage();
                        }}
                        value={search}
                    />
                </div>
                <div className={`${pageClassName}__table`}>
                    <Table
                        header={tableHeader}
                        data={data?.result?.data ?? []}
                        loading={isLoading || isFetching}
                        firstLoad={isLoading}
                        sortHandler={sortHandler}
                        minWidth="1000"
                        startIndex={data?.result?.from}
                        sortBy={query.sortBy}
                        viewURL={ROUTE.OKTA_DEVICE_LIST}
                        cursorPointer
                    />
                </div>
                <Divider />
                <div className={`${pageClassName}__pagination`}>
                    <div className={`${pageClassName}__pagination__limit`}>
                        <p>Display</p>
                        <div className={`${pageClassName}__pagination__dropdown`}>
                            <Dropdown
                                options={[
                                    { label: "20", value: 20 },
                                    { label: "50", value: 50 },
                                    { label: "100", value: 100 },
                                ]}
                                selected={{ label: query.limit, value: query.limit }}
                                onClickChange={(e) => {
                                    limitChangeHandler(e.value as number);
                                    handleFirstPage();
                                }}
                                isBordered
                                isIcon
                            />
                        </div>
                    </div>
                    <div className={`${pageClassName}__pagination__number`}>
                        {data?.result?.total ? (
                            <p>
                                Show {data?.result?.from} -{" "}
                                {data?.result?.from + query.limit - 1 < data?.result?.total
                                    ? data?.result?.from + query.limit - 1
                                    : data?.result?.total}{" "}
                                of {data?.result?.total}
                            </p>
                        ) : (
                            <p>Show 00 - 00 of 00</p>
                        )}
                    </div>
                    <div className={`${pageClassName}__pagination__nav`}>
                        {data?.result?.total > query.limit && (
                            <Pagination
                                totalData={totalData}
                                page={query.current}
                                handleFirstPage={handleFirstPage}
                                handlePrevPage={handlePrevPage}
                                handleLastPage={handleLastPage}
                                handleNextPage={handleNextPage}
                                renderPageNumbers={renderPageNumbers}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
